"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findItems = exports.escapedRegExpFromString = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var escapedRegExpFromString = function escapedRegExpFromString(str) {
  var espacedSpecialWords = str.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
  var allowMoreWhiteSpaces = espacedSpecialWords.replace(/\s/g, '\\s*');
  return allowMoreWhiteSpaces;
};

exports.escapedRegExpFromString = escapedRegExpFromString;

var findItems = function findItems(_ref) {
  var queryText = _ref.queryText,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!queryText || queryText.length === 0) {
    return [];
  }

  var regex = new RegExp("\\b".concat(escapedRegExpFromString(queryText)), 'gi');
  var filteredItems = items.filter(function (item) {
    return item.label.search(regex) >= 0;
  }).map(function (item) {
    var offset = 0;
    var match = true;
    var label = item.label;
    var itemsSplitted = [];

    while (match) {
      match = regex.exec(label);

      if (!match) {
        break;
      }

      var _match = match,
          index = _match.index;
      var lastIndex = regex.lastIndex;

      if (index > 0) {
        itemsSplitted.push({
          text: label.substring(offset, index),
          index: offset
        });
      }

      itemsSplitted.push({
        text: label.substring(index, lastIndex),
        hightlight: true,
        index: index
      });
      offset = lastIndex;
    }

    if (offset < label.length) {
      itemsSplitted.push({
        text: label.substring(offset, label.length),
        index: offset
      });
    }

    return _objectSpread(_objectSpread({}, item), {}, {
      itemsSplitted: itemsSplitted
    });
  });
  return filteredItems;
};

exports.findItems = findItems;